import React from "react";

const CloseOutlineIcon = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
			{...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.21967 3.21967C2.92678 3.51256 2.92678 3.98744 3.21967 4.28033L7.86955 8.93021L3.21974 13.58C2.92685 13.8729 2.92685 14.3478 3.21974 14.6407C3.51263 14.9336 3.98751 14.9336 4.2804 14.6407L8.93021 9.99087L13.58 14.6407C13.8729 14.9336 14.3478 14.9336 14.6407 14.6407C14.9336 14.3478 14.9336 13.8729 14.6407 13.58L9.99087 8.93021L14.6408 4.28033C14.9337 3.98744 14.9337 3.51256 14.6408 3.21967C14.3479 2.92678 13.873 2.92678 13.5801 3.21967L8.93021 7.86955L4.28033 3.21967C3.98744 2.92678 3.51256 2.92678 3.21967 3.21967Z"
				fill="#EFF0F6"
			/>
		</svg>
	);
};

export default CloseOutlineIcon;
